module.exports = __webpack_public_path__ + "static/media/imageBA.a502411c.webp";